import { Component, Input, OnInit } from '@angular/core';
import { DFCountryVariableCharges } from 'app/df-management/shared/df-management-admin-data.modal';
import { DfManagementService } from 'app/df-management/shared/df-management.service';
import { NavigationService } from 'app/shared/services/navigation.service';
import { CalendarService } from '../../calendar.service';

@Component({
  selector: 'app-view-country-form',
  templateUrl: './view-country-form.component.html',
  styleUrls: ['./view-country-form.component.scss']
})
export class ViewCountryFormComponent implements OnInit {

  private static  viewCountry = 'ViewCountry';
  private static  custom = 'Custom';
  @Input() countryData: DFCountryVariableCharges;
  @Input() isEditVisible;
  selectedYear: number;
  months: any[];
  years: number[] = [];
  isModalOpen = false;
  bufferDays: string;
  isCalendarEnabled = false;

  constructor(
    private dfManagementService: DfManagementService,
    public navigationService: NavigationService,
    private calendarService: CalendarService
    ) { }

  ngOnInit(): void {
    this.years = this.generateYears(2024, 2050);
    this.selectedYear = this.calendarService.getSelectedYear() || this.years[0];
    this.calendarService.setSelectedCountry(this.countryData.country_code);
    if (ViewCountryFormComponent.custom === this.countryData.country_job_frequency_details.fixed_charge_frequency) {
      this.isCalendarEnabled = true;
    }
    this.dfManagementService.getFlexibleCalendarData(this.countryData.country_code, this.selectedYear).subscribe((response: any) => {
      if (response) {
      this.bufferDays = response[0].voucher_grace_days,
      this.months = response.map(item => ({
        id: item.id,
        name: item.month,
        startDate: this.formatDate(item.month_start_date),
        endDate: this.formatDate(item.month_end_date),
        voucherJobRunDate: this.formatDate(item.voucher_update_date),
        year: item.year,
        bufferDays: item.voucher_grace_days,
        createdDate: item.created_date,
        updatedDate: item.update_date
        }));
      }
    },
    (error: any) => {
      console.log('::::: Error: ::::::', error);
    })
  }

 formatDate(dateString: string): string {
    if (!dateString) {
      return 'YYYY-MM-DD';
    }
    const date = new Date(dateString);
    const year = date.getFullYear();
    let month = (date.getMonth() + 1).toString();
    let day = date.getDate().toString();
    month = month.length === 1 ? '0' + month : month;
    day = day.length === 1 ? '0' + day : day;
    return year + '-' + month + '-' + day;
  }

  openModal(): void {
    this.isModalOpen = true;
    this.isEditVisible = false;
    this.calendarService.setFormType(ViewCountryFormComponent.viewCountry);
    this.calendarService.setEditableCalendar(true);
  }

  closeModal(): void {
    this.isModalOpen = false;
  }

  addNewYear() {
    this.openModal();
  }

  generateYears(startYear: number, endYear: number): number[] {
    const years: number[] = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  }

  calendarDatesNavigation(): void {
    this.navigationService.dfVariableChargesManagemnt().addCalendar().go();
    this.calendarService.setSelectedYear(this.selectedYear);
    this.calendarService.setFormType(ViewCountryFormComponent.viewCountry);
  }

}
